import Vue from "vue";
import Router from "vue-router";
import store from "./store/store.js"

import Home from "./components/pages/Home.vue";
import Projects from "./components/pages/Projects.vue";
import ProjectCreationContainer from "./components/pages/project/ProjectCreationContainer.vue";

import Section1 from "./components/pages/project/Section1";
import Section2 from "./components/pages/project/Section2";

import Section3 from "./components/pages/project/Section3";
import Section4 from "./components/pages/project/Section4";
import Renewal from "./components/pages/project/Renewal";

import AccountPage from "./components/pages/Account.vue";
import CreateAccount from "./components/pages/CreateAccount.vue";
import Help from "./components/pages/Help.vue";

// function isLoggedIn(){
//   console.log("Checking if logged in:", store.state.);
//   return  store.state.user.email !== null;
// }

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { showMainNav: true },
      beforeEnter: (to, from, next) => {

        if (store.getters['account/isLoggedIn']){
          next('/projects')
        } else {
          next()
        }

      }
    },
    {
      path: "/signup",
      name: "signup",
      component: CreateAccount,
      meta: {showMainNav: true}
    },
    // {
    //   path: "/gettingStarted",
    //   name: "gettingStarted",
    //   component: GettingStarted,
    //   meta: { showMainNav: true }
    // },
    // {
    //   path: "/resources",
    //   name: "resources",
    //   component: Resources,
    //   meta: { showMainNav: true }
    // },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      meta: {showMainNav: true},
    },
    {
      path: "/edit/:projectId",
      component: ProjectCreationContainer,
      children: [
        { path: "", component: Section1, name: "editProject"},
        { path: "1", component: Section1 },
        { path: "2", component: Section2 },
        { path: "3", component: Section3 },
        { path: "4", component: Section4 },
        {
          path: "5",
          component: Renewal,
          beforeEnter: (to, from, next) => {

            // Make sure state of validity is updated before checking if we can enter this route
            store.dispatch('rx/validateProjectState')
              .then(
                () => {
                  const reportIsAllowed = store.getters['rx/projectIsValid'];
                  // const reportIsAllowed = store.state['rx/currentProjectIsValid/section/5'];
                  console.log("Report access allowed:", reportIsAllowed);
                  if (reportIsAllowed){
                    next()
                  } else {
                    // console.log("Project is not valid", store.getters['rx/projectIsValid']);
                    // Go back to where you came from!
                    next(from)
                  }
                }
              )
          }
        }
      ]
    },
    {
      path: "/account",
      name: "account",
      component: AccountPage,
      meta: { showMainNav: true }
    },
    {
      path: "/help",
      name: "help",
      component: Help,
      meta: { showMainNav: true },
    }
  ]
});

router.beforeEach( (to, from, next) => {
    console.log("Running global route guards");
    if (store.getters['account/isLoggedIn'] || to.path === '/' || to.path === '/signup'){
      next()
    } else {
      next("/")
    }
});

export default router